import React from "react"
import {Deal} from "@irati/types"
import {H4} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Markdown from "@irati/ui/src/Markdown"
import {Hr} from "@irati/ui/src/Layout"

interface Props {
  id?: string
  deal: Deal
}

const ContactInfo: React.FC<Props> = ({deal}) => {
  if (!deal.contactInfo) {
    return null
  }
  return (
    <>
      <Hr />
      <H4 marginBottom={2}>
        <FormattedMessage id="perks.components.dealInfoBlock.contactInfo.text" />
      </H4>
      <Markdown source={deal.contactInfo} overflowWrap="break-word" />
    </>
  )
}

export default ContactInfo
